<ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
<ng-template #contentTemplate>
  <div class="d-flex flex-column h-100">
    <div class="offcanvas-header d-flex justify-content-between py-0">
      <h4 class="offcanvas-title">
        <!--<span class="pe-3">Scheduler Job ID : {{selectedJob.schedulerJobId == -1 ? "NA" : selectedJob.schedulerJobId}}</span>-->
        <span class="pe-3">Job Name : {{ selectedJob.name }}</span>
      </h4>
      <div class="job-status me-3" [ngClass]="getStatusClass(selectedJob.status)">
        {{ selectedJob.state }} - {{ selectedJob.stage }} - {{ selectedJob.status }}
      </div>
      <button type="button" class="actionBtn ms-3" (click)="maximizeAdvancedView(isMaximized)" [matTooltip]="isMaximized ? 'Restore' : 'Maximize'">
        <mat-icon style="color: red;">{{isMaximized ? 'fullscreen_exit' : 'fullscreen'}}</mat-icon>
      </button>
      <button type="button" class="actionBtn" (click)="close()" matTooltip="Close">
        <mat-icon style="color: red;">close</mat-icon>
      </button>
    </div>
    <div class="offcanvas-body flex-grow-1 py-0 pt-1 d-flex flex-column">
      <div class="options">
        <p (click)="openJobDetails()" [ngClass]="{ active: active === 1 }" title="Job Details of {{ selectedJob.name }}">
          Job Details
        </p>
        <p (click)="openJobSyncstore()" title="Permanent Storage" *ngIf="selectedJob.state !== jobGlobalStateDelete" [ngClass]="{ active: active === 2 }">
          Syncstore
        </p>
        <p (click)="openJobWorkstore()" title="Temporary Storage" *ngIf="selectedJob.state !== jobGlobalStateDelete" [ngClass]="{ active: active === 3 }">
          Workstore
        </p>
        <div class="btn-group" ngbDropdown container="body" role="group"
          aria-label="Button group with nested dropdown"
          *ngIf="selectedJob.state !== jobGlobalStateDelete">
          <button class="default-btn" ngbDropdownToggle>Actions</button>
          <div class="dropdown-menu" ngbDropdownMenu>
            @for (action of getJobActionsForThisJob; track action.actionName) {
              <button ngbDropdownItem [title]="action.actionName" (click)="emitJobAction(action)"><span class="text-dark" style="font-size: small;">{{ action.actionName }}</span></button>
            } @empty {
              <button ngbDropdownItem disabled>No actions available</button>
            }
          </div>
        </div>
      </div>
      <div class="childs flex-grow-1">
        <router-outlet (jobUpdated)="jobUpdated($event)"></router-outlet>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #noContent>
  <p class="pt-5 text-center">Something went wrong!</p>
</ng-template>
